export default "__VITE_ASSET__eM5HYHY2__"